var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_2",
    x: 4,
    y: 4,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#aeaec0",
    floodOpacity: 0.404
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Znachki",
    transform: "translate(-105 -113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_920",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 920"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105, 113)",
    filter: "url(#\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_2-2",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 2",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(11 11)",
    fill: "#f0f0f3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 105, 113)",
    filter: "url(#\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_1-2",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 1",
    width: 40,
    height: 40,
    rx: 8,
    transform: "translate(11 11)",
    fill: "#f0f0f3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Sep-16-21-19-47",
    transform: "translate(101.978 400.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_885",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 885",
    d: "M22.195-244.714a1.8,1.8,0,0,0,.007,1.371c.137.257.321.271,4,.314l3.857.029v-2H26.2C22.421-245,22.332-245,22.195-244.714Z",
    transform: "translate(-0.037 -19.028)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_886",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 886",
    d: "M221-244v1l3.856-.029c3.678-.043,3.863-.057,4-.314a1.8,1.8,0,0,0,.007-1.371c-.137-.286-.226-.286-4-.286H221Z",
    transform: "translate(-182.978 -19.028)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_888",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 888",
    d: "M22.157-148.714a1.993,1.993,0,0,0,0,1.429c.134.286.176.286,6.493.286h6.365v-2H28.65C22.334-149,22.291-149,22.157-148.714Z",
    transform: "translate(-0.002 -107.736)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_889",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 889",
    d: "M317.3-148v1h.623c.706,0,.949-.257.949-1s-.243-1-.949-1H317.3Z",
    transform: "translate(-272.85 -107.736)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_891",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 891",
    d: "M22.4-52.664a1.461,1.461,0,0,0-.228,1.647c.144.277.251.291,1.58.291h1.42l-.008-.976-.015-.991-1.314-.029A7.11,7.11,0,0,0,22.4-52.664Z",
    transform: "translate(0 -196.698)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_892",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 892",
    d: "M145.3-52v1h6.474c6.391,0,6.48,0,6.618-.286a1.79,1.79,0,0,0-.007-1.371c-.137-.257-.364-.271-6.618-.314L145.3-53Z",
    transform: "translate(-112.507 -196.444)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_181",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 181",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(26.022 -251.592)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_182",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 182",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(37.022 -258.592)",
    fill: "#2066a3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_183",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 183",
    width: 6,
    height: 6,
    rx: 2,
    transform: "translate(31.022 -266.592)",
    fill: "#2066a3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9537d4ec55ba8b7abe404e67e6eb8365.svg";
export { ForwardRef as ReactComponent };